import React, { FC, useState } from "react";
import { Modal } from "antd";
import _ from "lodash";

const FirstCADIframeModal: FC<{
  onClose: () => void;
  isModalVisible?: boolean;
}> = (props) => {
  const { onClose, isModalVisible } = props;

  const handleCancel = () => {
    onClose && onClose();
  };

  return (
    <Modal
      title={""}
      visible={isModalVisible}
      onOk={handleCancel}
      onCancel={handleCancel}
      width="80vw"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <iframe
        title="First CAD"
        src={`${process.env.REACT_APP_SHARED_URI}/911?userId=${localStorage.getItem('RID')}&connectionId=${localStorage.getItem('CID')}`}
        width="100%"
        height={window.innerHeight * 0.8}
        frameBorder="0"
      />
    </Modal>
  );
};

export default FirstCADIframeModal;
